module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/generic-loading-box/generic-loading-box.component.scss
// module id = ./src/app/modules/common-module/components/generic-loading-box/generic-loading-box.component.scss
// module chunks = 9